module.exports = __webpack_public_path__ + "img/avantage-marche.a4d6d0da.svg";